import { render, staticRenderFns } from "./detailBtn.vue?vue&type=template&id=c99dcb0e&scoped=true"
import script from "./detailBtn.vue?vue&type=script&lang=js"
export * from "./detailBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99dcb0e",
  null
  
)

export default component.exports